import { render, staticRenderFns } from "./stamping.vue?vue&type=template&id=1f5e99c8&scoped=true&"
import script from "./stamping.vue?vue&type=script&lang=ts&"
export * from "./stamping.vue?vue&type=script&lang=ts&"
import style0 from "./stamping.vue?vue&type=style&index=0&id=1f5e99c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e99c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
